export const AUTH_PARAM_WAIT_TIMEOUT_MS = 2000

export const AUTH_ERROR_CODE = {
  // Missing auth payload on first launch after waiting for partner/webview params.
  MISSING_AUTH_PARAMS: "BE-AUTH-001",
  // Upstream auth provider explicitly returned an OAuth-style error in the URL.
  PROVIDER_DENIED: "BE-AUTH-002",
  // Persisted token flow was requested but we could not restore a usable token.
  PERSISTED_TOKEN_INVALID: "BE-AUTH-003",
  // Access token exchange from auth code / partner code failed.
  TOKEN_EXCHANGE_FAILED: "BE-AUTH-004",
  // Token exchange succeeded but backend returned an empty or invalid access_token.
  TOKEN_EMPTY: "BE-AUTH-005",
  // Catch-all for unexpected auth failures that do not match a known stage.
  UNKNOWN: "BE-AUTH-999",
} as const

export type AuthErrorCode =
  (typeof AUTH_ERROR_CODE)[keyof typeof AUTH_ERROR_CODE]

export const getUnauthorizedPath = (
  errorCode?: AuthErrorCode,
  options?: {
    sessionExpired?: boolean
  }
) => {
  const searchParams = new URLSearchParams()

  if (errorCode) {
    searchParams.set("error_code", errorCode)
  }

  if (options?.sessionExpired) {
    searchParams.set("session_expired", "true")
  }

  const queryString = searchParams.toString()

  return queryString ? `/unauthorized?${queryString}` : "/unauthorized"
}
